import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import './badge-group.scss';

const BadgeGroupTypes = {
  PRIMARY: 'bg-primary',
  SUCCESS: 'bg-success',
  WARNING: 'bg-warning',
  ERROR: 'bg-error',
};

const BadgeGroupSizes = {
  MEDIUM: 'bg-medium',
  LARGE: 'bg-large',
};

const BadgeGroup = ({
  text, className, message, type, size,
}) => (
  <div className={clsx('badge-group-cont', type, size, className)}>
    <div className="badge-group-text">{text}</div>
    <div className="badge-group-message">{message}</div>
  </div>
);

BadgeGroup.defaultProps = {
  text: '',
  message: '',
  className: '',
  type: BadgeGroupTypes.PRIMARY,
  size: BadgeGroupSizes.MEDIUM,
};

BadgeGroup.propTypes = {
  text: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BadgeGroupTypes)),
  size: PropTypes.oneOf(Object.values(BadgeGroupSizes)),
};

export {
  BadgeGroup as default,
  BadgeGroupTypes,
  BadgeGroupSizes,
};
